// Version utility - placeholders will be replaced during build
export const NILE_ELEMENTS_VERSION = '__NILE_ELEMENTS_VERSION__';
export const NILE_VERSION = '__NILE_VERSION__';

// Set global versions for runtime access
if (typeof window !== 'undefined') {
  (window as any).nileElementsVersion = NILE_ELEMENTS_VERSION;
  (window as any).nileVersion = NILE_VERSION;
  window.process = window.process || { env: { NODE_ENV: 'production' } };
}
